/**
 * General actions script file
 *
 * @package    Actions
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import GeneralApi from 'Api/general';
import { transformAirport } from 'Utils';

export const SET_LOCALE = 'SET_LOCALE';

/**
 * Set locale
 *
 * @param {String} locale
 *
 * @returns {Object}
 */
export function setLocale (locale) {
    document.documentElement.lang = locale;

    return {
        locale,
        type: SET_LOCALE,
    };
}

export function loadAirports (search) {
    return function (dispatch) {
        return dispatch({
            request: GeneralApi.loadAirports(search),
            requestType: 'AIRPORT_LIST',
            successCallback: (data) => {
                return {
                    data: data.map((airport) => {
                        const label = transformAirport(airport);

                        return {
                            label,
                            value: label,
                        };
                    }),
                };
            },
        });
    };
}
